// «No vender ni compartir mi información» en la página del negocio.
//
// Dos señales, cualquiera basta:
//   - la cookie `redy_optout=1` que deja el enlace «Your Privacy Choices» del pie;
//   - Global Privacy Control: `navigator.globalPrivacyControl === true` en el
//     navegador y la cabecera `Sec-GPC: 1` en el servidor (California la exige
//     como exclusión válida).
// Con exclusión no se carga ningún script de terceros. El PR 4 la usa además
// para no mandar el Purchase desde el servidor.
import { readCookie } from "@/lib/marketing/signupAttribution"

export const OPTOUT_COOKIE = "redy_optout"
const OPTOUT_MAX_AGE_S = 2 * 365 * 24 * 60 * 60

export function isOptedOutClient(
  doc: { cookie: string },
  nav: { globalPrivacyControl?: boolean } | undefined,
): boolean {
  if (nav?.globalPrivacyControl === true) return true
  return readCookie(doc.cookie, OPTOUT_COOKIE) === "1"
}

export function isOptedOutServer(headers: { get(name: string): string | null }): boolean {
  if (headers.get("sec-gpc")?.trim() === "1") return true
  return readCookie(headers.get("cookie"), OPTOUT_COOKIE) === "1"
}

/** Marca o quita la exclusión en este host. */
export function setOptOut(doc: { cookie: string }, on: boolean, secure: boolean): void {
  const s = secure ? "; Secure" : ""
  doc.cookie = on
    ? `${OPTOUT_COOKIE}=1; Path=/; Max-Age=${OPTOUT_MAX_AGE_S}; SameSite=Lax${s}`
    : `${OPTOUT_COOKIE}=; Path=/; Max-Age=0; SameSite=Lax${s}`
}
